import { FC } from 'react';
import { MetaData } from '@edikk-edikk/country-common';
import { useAdvertListContext } from '#advertList/hooks/use-advert-list-context';

const AdvertListMetaData: FC = () => {
  const { seo } = useAdvertListContext();

  return <MetaData seo={seo} />;
};

export { AdvertListMetaData };
